/**
 * Format the date from Dilicom. Entry exemple :  '20210604' or '20210604-xxx-UTCxx'
 * @param {string} date The date to correct.
 * @returns {string} Corrected date : 04/06/2021
 */
const formatDate = (date: string) => {
    try {
        const year: string = date.substring(0, 4);
        const month: string = date.substring(4, 6);
        const day: string = date.substring(6, 8);
        return `${day}/${month}/${year}`;
    } catch (error) {
        return date;
    }
};

export const getReleaseDate = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].PublishingDetail[0].PublishingDate[0].Date[0];
        return formatDate(path._) || formatDate(path);
    } catch (error) {
        return "";
    }
};

export const getTitleData = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].DescriptiveDetail[0].TitleDetail[0].TitleElement[0].TitleText[0];
        return path._ || path;
    } catch (error) {
        return "";
    }
};

export const getCollectionData = (dataTitle: any): string => {
    try {
        const path = dataTitle.data[0].DescriptiveDetail[0].Collection;
        for (let i = 0; i < path.length; i++) {
            if (path[i].CollectionType[0] === "11") {
                const collection = path[i].TitleDetail[0].TitleElement[0].TitleText[0];
                if (typeof collection === "string") {
                    return collection;
                }
                if (typeof collection === "object" && typeof collection._ === "string") {
                    return collection._;
                }
            }
        }
        return "";
    } catch (error) {
        return "";
    }
};

export const getSummaryData = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].CollateralDetail[0].TextContent; // array of objects
        // Find object with key --> TextType: ['03']
        for (let i = 0; i < path.length; i++) {
            if (path[i].TextType[0] === "03") {
                return path[i].Text[0]._ || path[i].Text[0];
            }
        }
    } catch (error) {
        return "";
    }
    // return synopsisPath[0].Text[0];
};

export const getImageData = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].CollateralDetail[0].SupportingResource;
        for (let i = 0; i < path.length; i++) {
            if (path[i].ResourceContentType[0] === "01") {
                return path[i].ResourceVersion[0].ResourceLink[0];
            }
        }
    } catch (error) {
        return "";
    }
};

export const getPrice = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].ProductSupply[0].SupplyDetail[0].Price[0].Tax[0].TaxableAmount[0];
        return path;
    } catch (error) {
        return "";
    }
};

export const getFormatData = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].DescriptiveDetail[0];
        if (path.Measure.length < 2) {
            return "-";
        }
        if (path.Measure.length === 2) {
            return `${path.Measure[0].Measurement[0]} x ${path.Measure[1].Measurement[0]} ${path.Measure[0].MeasureUnitCode[0]}`;
        } else {
            return `${path.Measure[0].Measurement[0]} x ${path.Measure[1].Measurement[0]} x ${path.Measure[2].Measurement[0]} ${path.Measure[0].MeasureUnitCode[0]}`;
        }
    } catch (error) {
        return "";
    }
};

export const getPageNumber = (dataTitle: any) => {
    try {
        const path = dataTitle.data[0].DescriptiveDetail[0];
        return path.Extent[0].ExtentValue[0];
    } catch (error) {
        return "";
    }
};

/*
Get ean13 from Dilicom Data -->

export const getEanData = (dataTitle: any) => {
    const path = dataTitle.data[0].ProductIdentifier;
    if (path) {
        for (let i = 0; i < path.length; i++) {
            // Find object with key --> ProductIDType: ['03']
            if (path[i].ProductIDType[0] === '03') {
                return path[i].IDValue[0];
            }
            // If no ProductIDType: ['03'], get ProductIDType: ['15']
            if (path[i].ProductIDType[0] === '15') {
                return path[i].IDValue[0];
            }
        }
    } else return "-";
}
*/
